module.exports = __webpack_public_path__ + "static/img/交資料囉300x300.2eb81db4.png";